import { YColumnsType } from '@ydistri/ds';
import React, { useCallback } from 'react';
import { SkuSizeResponse } from '@ydistri/api-sdk';
import { useCurrency } from '../../../../../../hooks/useCurrency';
import SkuDetailsTable from '../../../../../../components/domain/SkuDetailsTable/SkuDetailsTable';

interface DetailProductSizesTableProps {
  data: SkuSizeResponse[];
  showStoreColumns?: boolean;
}

const DetailProductSizesTable: React.FC<DetailProductSizesTableProps> = ({
  data,
  showStoreColumns = true,
}) => {
  const currency = useCurrency();

  const customizeColumns = useCallback((defaultColumns: YColumnsType<SkuSizeResponse>[]) => {
    // Find the index after store columns (before SKU Class)
    const skuClassIndex = defaultColumns.findIndex(
      col => Array.isArray(col.dataIndex) && col.dataIndex[0] === 'skuClass',
    );
    const insertIndex = skuClassIndex !== -1 ? skuClassIndex : 3;

    const sizeColumns: YColumnsType<SkuSizeResponse>[] = [
      {
        title: 'Size',
        dataIndex: 'productSize',
        width: '8rem',
        sorter: (left, right) => {
          return left.productSize?.localeCompare(right.productSize ?? '') ?? 0;
        },
      },
      {
        title: 'Product Name',
        dataIndex: ['product', 'name'],
      },
    ];

    const modifiedColumns = [...defaultColumns];
    modifiedColumns.splice(insertIndex, 1, ...sizeColumns);

    return modifiedColumns;
  }, []);

  return (
    <SkuDetailsTable
      data={data}
      currency={currency}
      customizeColumns={customizeColumns}
      showStoreColumns={showStoreColumns}
    />
  );
};

export default DetailProductSizesTable;
